/*!
 * jQuery Plugin: Are-You-Sure (Dirty Form Detection)
 * https://github.com/codedance/jquery.AreYouSure/
 *
 * Copyright (c) 2012-2014, Chris Dance and PaperCut Software http://www.papercut.com/
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * Author:  chris.dance@papercut.com
 * Version: 1.9.0
 * Date:    13th August 2014
 */
(function areYouSureFce($) {
    $.fn.areYouSure = function areYouSureDefinition(options) {
        let settings = $.extend(
            {
                message: 'You have unsaved changes!',
                dirtyClass: 'dirty',
                change: null,
                silent: false,
                addRemoveFieldsMarksDirty: false,
                fieldEvents: 'change keyup propertychange input',
                fieldSelector: ':input:not(input[type=submit]):not(input[type=button])'
            }, options
        );

        let getValue = function getValue(field) {
            if (field.hasClass('ays-ignore')
          || field.hasClass('aysIgnore')
          || field.attr('data-ays-ignore')
          || field.attr('name') === undefined) {
                return null;
            }

            if (field.is(':disabled')) {
                return 'ays-disabled';
            }

            let val;
            let type = field.attr('type');
            if (field.is('select')) {
                type = 'select';
            }

            switch (type) {
            case 'checkbox':
            case 'radio':
                val = field.is(':checked');
                break;
            case 'select':
                val = '';
                field.find('option').each(function optionEach(o) {
                    let $option = $(this);
                    if ($option.is(':selected')) {
                        val += $option.val();
                    }
                });
                break;
            default:
                val = field.val();
            }

            return val;
        };

        let storeOrigValue = function storeOrigValue(field) {
            field.data('ays-orig', getValue(field));
        };

        let checkForm = function checkForm(evt) {
            let isFieldDirty = function isFieldDirty(field) {
                let origValue = field.data('ays-orig');
                if (undefined === origValue) {
                    return false;
                }
                return (getValue(field) !== origValue);
            };

            let form = ($(this).is('form'))
                ? $(this)
                : $(this).parents('form');

            // Test on the target first as it's the most likely to be dirty
            if (isFieldDirty($(evt.target))) {
                setDirtyStatus(form, true);
                return;
            }

            let fields = form.find(settings.fieldSelector);

            if (settings.addRemoveFieldsMarksDirty) {
                // Check if field count has changed
                let origCount = form.data('ays-orig-field-count');
                if (origCount !== fields.length) {
                    setDirtyStatus(form, true);
                    return;
                }
            }

            // Brute force - check each field
            let isDirty = false;
            fields.each(function fieldsEach() {
                let field = $(this);
                if (isFieldDirty(field)) {
                    isDirty = true;
                    return false; // break
                }
            });

            setDirtyStatus(form, isDirty);
        };

        let initForm = function initForm(form) {
            let fields = form.find(settings.fieldSelector);
            $(fields).each(function fieldsEach() { storeOrigValue($(this)); });
            $(fields).unbind(settings.fieldEvents, checkForm);
            $(fields).bind(settings.fieldEvents, checkForm);
            form.data('ays-orig-field-count', $(fields).length);
            setDirtyStatus(form, false);
        };

        let setDirtyStatus = function setDirtyStatus(form, isDirty) {
            let changed = isDirty !== form.hasClass(settings.dirtyClass);
            form.toggleClass(settings.dirtyClass, isDirty);

            // Fire change event if required
            if (changed) {
                if (settings.change) settings.change.call(form, form);

                if (isDirty) form.trigger('dirty.areYouSure', [form]);
                if (!isDirty) form.trigger('clean.areYouSure', [form]);
                form.trigger('change.areYouSure', [form]);
            }
        };

        let rescan = function rescan() {
            let form = $(this);
            let fields = form.find(settings.fieldSelector);
            $(fields).each(function fieldsEach() {
                let field = $(this);
                if (!field.data('ays-orig')) {
                    storeOrigValue(field);
                    field.bind(settings.fieldEvents, checkForm);
                }
            });
            // Check for changes while we're here
            form.trigger('checkform.areYouSure');
        };

        let reinitialize = function reinitialize() {
            initForm($(this));
        };

        if (!settings.silent && !window.aysUnloadSet) {
            window.aysUnloadSet = true;
            $(window).bind('beforeunload', () => {
                let dirtyForms = $('form').filter(`.${settings.dirtyClass}`);
                if (dirtyForms.length === 0) {
                    return;
                }
                // Prevent multiple prompts - seen on Chrome and IE
                if (navigator.userAgent.toLowerCase().match(/msie|chrome/)) {
                    if (window.aysHasPrompted) {
                        return;
                    }
                    window.aysHasPrompted = true;
                    window.setTimeout(() => { window.aysHasPrompted = false; }, 900);
                }
                return settings.message;
            });
        }

        return this.each(function thisEach(elem) {
            if (!$(this).is('form')) {
                return;
            }
            let form = $(this);

            form.submit(() => {
                form.removeClass(settings.dirtyClass);
            });
            form.bind('reset', () => { setDirtyStatus(form, false); });
            // Add a custom events
            form.bind('rescan.areYouSure', rescan);
            form.bind('reinitialize.areYouSure', reinitialize);
            form.bind('checkform.areYouSure', checkForm);
            initForm(form);
        });
    };
}(jQuery));
